module.exports = __webpack_public_path__ + "img/2.0d9bc884.jpg";